import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { fg } from '@atlaskit/platform-feature-flags';
import Textfield from '@atlaskit/textfield';
import { getInputAccessibilityDescriptionId } from '../common/accessibilityUtils';
import { ShortTextFieldWrapper } from '../common/questionWrappers';
export var EditShortText = function EditShortText(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  // Local state required to show textfield changes as onChange callback is debounced.
  // Without it, user will only see their last inputted character added within the debounce period.
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    textFieldValue = _useState2[0],
    setTextFieldValue = _useState2[1];
  useEffect(function () {
    setTextFieldValue(value);
  }, [value]);
  var debouncedOnChange = useMemo(function () {
    return onChange ? debounce(onChange, fg('proforma_reduce_debounce_for_csm') ? 250 : 500) : noop;
  }, [onChange]);
  var handleTextFieldChange = useCallback(function (e) {
    e.persist();
    setTextFieldValue(e.target.value);
    debouncedOnChange(e);
  }, [debouncedOnChange]);
  return /*#__PURE__*/React.createElement(ShortTextFieldWrapper, {
    isDisabled: false
  }, /*#__PURE__*/React.createElement(Textfield, {
    id: id,
    value: textFieldValue,
    isInvalid: isInvalid,
    onChange: handleTextFieldChange,
    width: "medium",
    label: label,
    "aria-label": label,
    title: label,
    placeholder: "",
    isRequired: isRequired,
    "aria-describedby": fg('jsm-accessibility-fixes') ? getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) : undefined
  }));
};